<template>
  <div class="list">
    <div class="list__header">
      <div class="list__cell list__cell-score">Keyword Relevancy Score</div>
      <div class="list__cell list__cell-msv">MSV</div>
      <div class="list__cell list__cell-keywords"># of Keywords</div>
    </div>
    <div class="list__row" v-for="item in list" :key="item.score">
      <div class="list__cell list__cell-score">{{item.score}}</div>
      <div class="list__cell list__cell-msv">{{item.msv | roundNumber | commaDividedNumber}}</div>
      <div class="list__cell list__cell-keywords">{{item.keywords | commaDividedNumber}}</div>
    </div>
    <div class="list__footer">
      <div class="list__cell list__footer-cell-score">Total</div>
      <div class="list__cell list__cell-msv">{{total.msv | roundNumber | commaDividedNumber}}</div>
      <div class="list__cell list__cell-keywords">{{total.keywords | commaDividedNumber}}</div>
    </div>
  </div>
</template>

<script>
import filters from '@/common/Filters'
// eslint-disable-next-line no-unused-vars
import RelevancyReport from './RelevancyReport'

/**
 * Keyword Relevancy Score statistic
 * used in {@link RelevancyReport} component
 */
export default {
  name: 'Keyword',
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    list () {
      return this.data.list
    },
    total () {
      return this.data.total
    }
  },
  filters: {
    ...filters
  }

}
</script>

<style scoped lang="scss">

  .list {
    padding: 30px 40px;
    flex: 1 1;
    display: flex;
    flex-direction: column;

    &__header,
    &__footer,
    &__row {
      display: flex;
      font-size: 12px;
      color: $rfx-dark-march;
      padding: 0 16px;
      height: 30px;
    }

    &__row {
      font-weight: 500;
    }

    &__header {
      border-bottom: 1px solid $rfx-grey;
    }

    &__cell {
      display: flex;
      align-items: center;
    }

    &__footer,
    &__header {
      font-size: 12px;
      font-weight: bold;
      color: $rfx-dark-march;
    }

    &__footer {
      display: flex;
      justify-content: stretch;
      border-top: 1px solid $rfx-grey;
    }
    &__footer-cell-score,
    &__cell-score {
      flex: 1 1 55%;
    }

    &__footer-cell-score {
      padding-right: 20px;
      box-sizing: border-box;
      justify-content: flex-end;
    }

    &__cell-msv {
      flex: 1 1 20%;
    }

    &__cell-keywords {
      flex: 1 1 25%;
      display: flex;
      justify-content: flex-end;

    }

  }
</style>
